const dataLayer = window.dataLayer || [];

const gtmEvents = {
  deviceUpdateNote: 'deviceUpdateNote',
  deviceCreateNote: 'deviceCreateNote',
  deviceDeleteNote: 'deviceDeleteNote',
};

const InstallationNotesModalController = (
  $scope,
  $rootScope,
  $uibModalInstance,
  installation,
  installationNoteService,
  gettextCatalog,
) => {
  'ngInject';

  $scope.installation = installation;
  $scope.notes = [];
  $scope.editing = {};
  $scope.editNote = {};
  $scope.loading = true;
  $scope.creatingnote = false;
  $scope.postingChange = false;

  $scope.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.$on('$locationChangeStart', (event, _next, _current) => {
    $scope.cancel();
    event.preventDefault();
  });

  $scope.toggleEditing = (note) => {
    $scope.editing[note.id] = !$scope.editing[note.id];
    $scope.editNote.text = note.text;
  };

  $scope.cancelEdit = (note) => {
    $scope.editing[note.id] = !$scope.editing[note.id];
    $scope.editNote.text = null;
  };

  // C.R.U.D Methods for Notes
  $scope.getInstallationNotes = () => {
    const installationId = $scope.installation.id;

    $scope.loading = true;
    installationNoteService.getInstallationNote(installationId).then(
      (response) => {
        $scope.notes = response.data.data;
        $scope.loading = false;
      },
      (error) => {
        let errorMsg = gettextCatalog.getString('An error occurred while retrieving alert notes');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = `${
              error.data.message
            } ${error.status.toString()} - ${error.statusText.toString()}`;
          } else {
            errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.onLoadErrorFlag = true;
        $scope.onLoadErrorText = errorMsg;
        $scope.loading = false;
      },
    );
  }; // getInstallationNotes

  $scope.getInstallationNotes($scope.installation);

  $scope.createNewNote = () => {
    $scope.creatingnote = true;
    const installationId = $scope.installation.id;
    const note = {};

    note.text = $scope.newNote.text;

    dataLayer.push({
      event: gtmEvents.deviceCreateNote,
      data: {
        installationId,
      },
    });

    installationNoteService.createNote(installationId, note).then(
      () => {
        $scope.getInstallationNotes(installationId);
        $scope.creatingnote = false;
        $scope.newNote.text = '';
      },
      (error) => {
        let errorMsg = gettextCatalog.getString('An error occurred while creating the note');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = `${
              error.data.message
            } ${error.status.toString()} - ${error.statusText.toString()}`;
          } else {
            errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
        $scope.creatingnote = false;
      },
    );
  };

  $scope.updateNote = (installationId, noteId, note) => {
    if ($scope.editNote.text !== '') {
      note.text = $scope.editNote.text;
      $scope.postingChange = true;

      dataLayer.push({
        event: gtmEvents.deviceUpdateNote,
        data: {
          installationId,
          noteId,
        },
      });

      installationNoteService.updateNote(installationId, noteId, note).then(
        () => {
          $scope.editing[note.id] = !$scope.editing[note.id];
          $scope.postingChange = false;
        },
        (error) => {
          let errorMsg = gettextCatalog.getString('An error occurred while updating the note');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = `${
                error.data.message
              } ${error.status.toString()} - ${error.statusText.toString()}`;
            } else {
              errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.errorFlag = true;
          $scope.errorText = errorMsg;
          $scope.postingChange = false;
        },
      );
    } else {
      $scope.isInvalidData = true;
    }
  }; // update note

  $scope.deleteNote = (installationId, noteId) => {
    dataLayer.push({
      event: gtmEvents.deviceDeleteNote,
      data: {
        installationId,
        noteId,
      },
    });

    installationNoteService.deleteNote(installationId, noteId).then(
      () => {
        $scope.getInstallationNotes(installationId);
      },
      (error) => {
        let errorMsg = gettextCatalog.getString('An error occurred while deleting the note');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = `${
              error.data.message
            } ${error.status.toString()} - ${error.statusText.toString()}`;
          } else {
            errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
      },
    );
  };
};

export default InstallationNotesModalController;
